import React, {createContext} from 'react';

export const rightContentWidthContext = createContext({});
export const UPDATE_RIGHT_CONTENT_WIDTH = 'UPDATE_RIGHT_CONTENT_WIDTH';
export const reducer = (state:any, action:any) => {
    switch(action.type) {
        case UPDATE_RIGHT_CONTENT_WIDTH:
            return action.width;
        default:
            return state;
    }
}
